var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,18.355c-11.739,0-24.214,3.931-24.214,11.215V66.43c0,7.284,12.476,11.215,24.214,11.215 c11.738,0,24.215-3.931,24.215-11.215V29.57C72.215,22.286,59.738,18.355,48,18.355z M68.215,66.43 c0,3.013-7.69,7.215-20.215,7.215c-12.524,0-20.214-4.202-20.214-7.215V54.379C32.407,57.55,40.36,59.215,48,59.215 c7.641,0,15.593-1.665,20.215-4.836V66.43z M68.215,48c0,3.013-7.69,7.215-20.215,7.215c-12.524,0-20.214-4.202-20.214-7.215 V35.949C32.407,39.12,40.36,40.785,48,40.785c7.641,0,15.593-1.665,20.215-4.836V48z M48,36.785 c-12.524,0-20.214-4.202-20.214-7.215s7.69-7.215,20.214-7.215c12.524,0,20.215,4.203,20.215,7.215S60.524,36.785,48,36.785z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.b3c6f8676e549e29623ac05ef01d92c9.svg";
export { ForwardRef as ReactComponent };